import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ContactsSearchQuery } from '../../../queries/contacts_search_query';

export class ContactListController {
  private search: boolean;
  constructor(
    private ngContactListService: any,
    private ngContactsSearchQuery: ContactsSearchQuery,
    private $state: ng.ui.IStateService
  ) {}

  isContactListEmpty(): boolean {
    return _4.isEmpty(this.ngContactListService.activeContacts);
  }

  hasSearchResults(): boolean {
    return !_4.isEmpty(this.ngContactsSearchQuery.result);
  }
}

export class ContactListComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-resources/src/components/people/contact_list/contact_list.html';
  public controller: any = ContactListController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    search: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/components/people/contact_list/contact_list_controller.ts